<app-sales-claro-credibanco (nextStepEvent)="onNextStep()" *ngIf="typePointSales === OptionPointSales['claro-credibanco'] "></app-sales-claro-credibanco>
<app-sales-exito-evertec (nextStepEvent)="onNextStep()" *ngIf="typePointSales === OptionPointSales['exito-evertec']"></app-sales-exito-evertec>
